import { Field, Stack } from "@chakra-ui/react";
import { FORM_GAP, FormError, LoginNotice, LoginUI } from "./loginUI";
import type { UseLoginForm } from "./useLoginForm";

export function ForgotPasswordForm({
  form,
  ui,
  onBackToLogin,
}: {
  form: UseLoginForm;
  ui: LoginUI;
  onBackToLogin: () => void;
}) {
  const {
    email,
    isValid,
    error,
    isLoading,
    resetSent,
    handleEmailChange,
    requestPasswordReset,
  } = form;

  return (
    // Same rhythm as the other login forms: one gap, no per-element margins.
    <Stack
      width="full"
      as="form"
      gap={FORM_GAP}
      onSubmit={(e) => {
        e.preventDefault();
        requestPasswordReset();
      }}
    >
      {/* Worded so it is true whether or not the email has an account: the
          server never says which. */}
      {resetSent && (
        <LoginNotice title="Check your inbox 💌">
          If there is an account for this email, we sent a link to reset the
          password. It works for 1 hour.
        </LoginNotice>
      )}

      <Field.Root invalid={!isValid} gap={FORM_GAP}>
        <Field.Label
          width="100%"
          justifyContent="center"
          textAlign={"center"}
          color="whiteAlpha.700"
        >
          Enter your email to reset your password
        </Field.Label>

        <ui.Input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={handleEmailChange}
        />

        <FormError isValid={isValid} error={error} />
      </Field.Root>

      <ui.SubmitButton isLoading={isLoading} disabled={isLoading}>
        Send reset link
      </ui.SubmitButton>

      <ui.GhostButton onClick={onBackToLogin}>Back to login</ui.GhostButton>
    </Stack>
  );
}
